export default __webpack_public_path__ + "d45598b470f62582bcdf438c6e111249.png";